import React from 'react';

interface NameColumnProps {
  fullName: string;
}

export default React.memo((props: NameColumnProps) => {
  return <>{props.fullName || '-'}</>;
});
